/**
 * npc_pick — who the T key talks to (2026-09-15, the versona review's item 1).
 *
 * The talk pick used to be the NEAREST resident in the XZ plane within
 * TALK_RANGE_M — in a square of ninety that is whoever happens to stand at
 * your elbow, not the one you walked up to and are facing. The pick is now
 * the nearest resident IN THE LOOK CONE (±60°, the same facing rule the
 * strike and the reticle use — forward = (−sin yaw, −cos yaw)); with nobody
 * in the cone it falls back to the nearest in range, so T still answers when
 * you turn your back on the only person there. Identity is the versona id
 * from the table rows end to end — never a render slot (the crowd instancer
 * repacks its instances every frame). Pure — the harness pins it.
 */

/** cos of the half-angle of the talk cone (±60°). */
export const TALK_CONE_COS = 0.5;

export interface PickCand { x: number; z: number }

/** The index of the resident to talk to, or -1 when nobody is within rangeM. */
export function pickConversant(px: number, pz: number, yaw: number, cands: ReadonlyArray<PickCand>, rangeM: number, cosMin = TALK_CONE_COS): number {
  const fx = -Math.sin(yaw), fz = -Math.cos(yaw);
  let inCone = -1, inConeD = Infinity, any = -1, anyD = Infinity;
  for (let i = 0; i < cands.length; i++) {
    const dx = cands[i].x - px, dz = cands[i].z - pz;
    const d = Math.hypot(dx, dz);
    if (d > rangeM) continue;
    if (d < anyD) { anyD = d; any = i; }
    const cos = d > 1e-6 ? (dx * fx + dz * fz) / d : 1;
    if (cos >= cosMin && d < inConeD) { inConeD = d; inCone = i; }
  }
  return inCone >= 0 ? inCone : any;
}
